import styles from './Tooltip.module.scss'

const { date, label, texts, tooltip } = styles

let activatedOnce = false
let lastPayload = []

const CustomTooltip = ({ payload, active, isVisible }) => {
  if (active) {
    activatedOnce = true
  }

  if (activatedOnce && isVisible) {
    if (payload.length > 0) {
      lastPayload = payload
    }

    return (
      <div className={tooltip}>
        <p className={date}>
          {lastPayload[0].payload.dateView}
          <span className={texts}>{lastPayload[0].payload.invitesSent} texts sent</span>
        </p>
        <p className={label}>
          <Circle color="#4079F5" />
          <strong>{lastPayload[0].payload.clickRate}%</strong> click rate
        </p>
        <p className={label}>
          <Circle color="#66BB6A" />
          <strong>{lastPayload[0].payload.clicks}</strong> clicks
        </p>
        <p className={label}>
          <Circle color="#FFC81E" />
          <strong>{lastPayload[0].payload.bookingsTotal}</strong> booking
        </p>
      </div>
    )
  }
  return null
}

const Circle = ({ color }) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill={color} />
  </svg>
)

export default CustomTooltip
